module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.scss
// module id = ./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.scss
// module chunks = 0